import { ConnectButton, IconWithLabel, Link } from "../Actions";

export const ConnectWalletSection: React.FC<{
  hideTitle?: boolean;
  connectButtonText?: string;
}> = ({ hideTitle, connectButtonText }) => (
  <div className="flex flex-col gap-4 items-center mt-4">
    <p className={`body1 text-coinage-body mb-4 ${hideTitle && "hidden"}`}>
      Connect your wallet to get started.
    </p>
    <ConnectButton buttonText={connectButtonText} />
    <Link analyticsProperty="needHelp" href="/novice" modifier="tertiary">
      <IconWithLabel icon="arrow" label="I need Help" />
    </Link>
  </div>
);
